<template>
  <div class="income">
    <div class="head">
      <Notice
        content="收益包含待结算佣金，订单包含已完成、已关闭、待支付及已支付的订单"
      ></Notice>
      <div class="info">
        <p class="text">通过的平台我已累计赚了</p>
        <p class="price">
          <icon-price size="max" :priceType="3" />{{ data.income | toFixPrice }}
        </p>
      </div>
      <div class="tab-wrap">
        <p
          class="tab"
          :class="{ active: curTab == item.value }"
          v-for="(item, index) in tabs"
          :key="index"
          @click="onTab(item)"
        >
          {{ item.label }}
        </p>
      </div>
    </div>
    <div class="body">
      <div class="price-box box vmiddle">
        <span class="label">收益：</span>
        <p class="price">
          <icon-price size="middle" :priceType="3" />{{
            data.current_income | toFixPrice
          }}
        </p>
      </div>
      <div class="order-box box">
        <p class="title">我的分销订单</p>
        <div class="bottom">
          <div class="item">
            <p class="price">
              <icon-price size="middle" :priceType="3" />{{
                data.self_commission | toFixPrice
              }}
            </p>
            <p class="label">分销佣金</p>
          </div>
          <div class="item">
            <p class="number">
              <span>{{ data.self_count }}</span
              ><span class="tag">笔</span>
            </p>
            <p class="label">订单数</p>
          </div>
        </div>
      </div>
      <div class="order-box box">
        <p class="title">我的邀请订单</p>
        <div class="bottom">
          <div class="item">
            <p class="price">
              <icon-price size="middle" :priceType="3" />{{
                data.subordinate_commission | toFixPrice
              }}
            </p>
            <p class="label">邀请佣金</p>
          </div>
          <div class="item">
            <p class="number">
              <span>{{ data.subordinate_count }}</span
              ><span class="tag">笔</span>
            </p>
            <p class="label">订单数</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notice from "@/components/distribute/Notice";
export default {
  name: "Income",
  components: {
    Notice
  },
  data() {
    return {
      curTab: "today",
      tabs: [
        { label: "今日", value: "today" },
        { label: "昨日", value: "yesterday" },
        { label: "本月", value: "month" },
        { label: "上月", value: "lastMonth" }
      ],
      data: {}
    };
  },
  created() {
    this.requestData();
  },
  methods: {
    // on event
    onTab(item) {
      this.curTab = item.value;
      this.requestData();
    },
    // request
    requestData() {
      this.$http
        .get("/api/app/distribute/myIncome", {
          date: this.curTab
        })
        .then(data => {
          this.data = data;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.income {
  @extend %default-bg;
  .head {
    position: relative;
    height: 312px;
    background: url("~@/assets/images/distribute/income-bg.png") center / cover
      no-repeat;
    overflow: hidden;
    .info {
      text-align: center;
      .text {
        font-size: 24px;
        color: rgba(255, 255, 255, 0.8);
        margin: 72px 0 20px 0;
      }
      .price {
        font-size: 44px;
        color: #fff;
      }
    }
    .tab-wrap {
      display: inline-flex;
      justify-content: space-between;
      position: absolute;
      bottom: 20px;
      width: 100%;
      font-size: 30px;
      color: rgba(255, 255, 255, 0.5);
      .tab {
        width: 150px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        &.active {
          font-size: 32px;
          color: #fff;
        }
      }
    }
  }
  .body {
    padding: 30px;
    .box {
      background-color: #fff;
      box-shadow: 0px 6px 30px 0px rgba(65, 105, 255, 0.04);
      border-radius: 20px;
      margin-bottom: 30px;
      padding: 22px;
    }
    .price-box {
      .label {
        font-size: 24px;
        color: #595959;
      }
      .price {
        display: inline-block;
        font-size: 36px;
        font-weight: 500;
        color: #20242a;
        &::first-letter {
          font-size: 24px;
        }
      }
    }
    .order-box {
      font-weight: 500;
      .title {
        font-size: 26px;
        color: #595959;
        padding-bottom: 20px;
        border-bottom: 2px solid #f5f5f5;
      }
      .bottom {
        display: flex;
        justify-content: space-between;
        .item {
          width: 50%;
          height: 180px;
          text-align: center;
          position: relative;
          &::after {
            content: "";
            display: block;
            width: 2px;
            height: 94px;
            background-color: #f5f5f5;
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
          }
          &:last-child::after {
            display: none;
          }
          .price {
            font-size: 36px;
            color: #595959;
            margin-top: 60px;
            &::first-letter {
              font-size: 24px;
            }
          }
          .label {
            font-size: 24px;
            color: #b7b7b7;
            margin-top: 10px;
          }
          .number {
            font-size: 36px;
            color: #595959;
            margin-top: 60px;
            .tag {
              font-size: 24px;
            }
          }
        }
      }
    }
  }
}
</style>
